"use client";

import { Toaster } from "react-hot-toast";
import { PrimeReactProvider } from "primereact/api";

export default function ClientProviders({ children }: { children: React.ReactNode }) {
	return (
		<PrimeReactProvider>
			{children}
			<Toaster position="top-right" />
		</PrimeReactProvider>
	);
}
